import { Component, Input } from '@angular/core';
import { Step0Data, Step1Data, Step2Data } from '../../models/diagnostic.models';

@Component({
  selector: 'app-step-tracker',
  templateUrl: './step-tracker.component.html',
  styleUrls: ['./step-tracker.component.scss']
})
export class StepTrackerComponent {
  @Input() step0: Step0Data;
  @Input() step1: Step1Data;
  @Input() step2: Step2Data;

  formatMoney(value: number): string {
    if (value === null || value === undefined) {
      return '-';
    }
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2
    }).format(value);
  }
}
